/* eslint-disable angular/no-service-method */
angular.module('app.services').service('sharedProperties', [
  '$rootScope',
  '$log',
  '$filter',
  '$window',
  function controller($rootScope, $log, $filter, $window) {
    let vm = this

    vm.isAdminSession = () => {
      return (
        !_.isEmpty($rootScope.user) &&
        $rootScope.user.roles.some(
          role => role.id === 'admin' || role.id === 'corporate'
        )
      )
    }

    vm.detectBrowser = () => {
      let M
      let tem
      let ua
      ua = navigator.userAgent
      tem = undefined
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || []
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || []
        return 'IE ' + (tem[1] || '')
      }

      if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem !== null) {
          return 'Opera ' + tem[1]
        }
      }

      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
      if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
        M.splice(1, 1, tem[1])
      }

      return M.join(' ')
    }

    vm.logOut = () => {
      $window.localStorage.setItem('logout', Date.now())
      $window.localStorage.removeItem('token')
      $window.localStorage.removeItem('user')
      $window.location.href = '/signin'
      return true
    }

    vm.isNullOrEmpty = data => {
      var isValid
      isValid = false
      isValid = Boolean(
        data === null || data === undefined || $.trim(data) === ''
      )
      return isValid
    }

    vm.setCVName = (firstName, lastName, cvCounter) => {
      var updatedFileName
      $log.info(firstName + lastName)
      $log.info(cvCounter)
      cvCounter++
      updatedFileName =
        $filter('date')(new Date(), 'yyMMdd') +
        '_' +
        firstName +
        lastName +
        '_CV' +
        cvCounter
      return updatedFileName
    }

    vm.isNotNullOrEmpty = data => {
      return !vm.isNullOrEmpty(data)
    }

    vm.getImgSrc = (img, userId = '', useBackendUrl = false) => {
      if (useBackendUrl) {
        return `${process.env.LEXSTEP_URL}/${userId}/${img}`
      }

      return `${process.env.PUBLIC_URL}/${userId}/${img}`
    }

    vm.getDefaultContactUsername = () => {
      return 'Lexstep'
    }

    vm.getDefaultContactEmail = () => {
      return 'jobs@lexstep.com'
    }

    vm.getDefaultContactPhone = () => {
      return '+44 (0)20 7060 9516'
    }

    vm.getAgentDetails = async agent => {
      let imageUrl = 'images/defaultPic.jpg'

      if (!agent || Object.keys(agent).length === 0) {
        imageUrl = 'images/lexstep_logo.jpeg'
        return {
          firstName: vm.getDefaultContactUsername(),
          lastName: '',
          email: vm.getDefaultContactEmail(),
          phone: vm.getDefaultContactPhone(),
          logoSrc: imageUrl,
        }
      }

      if (agent.profilePicture) {
        imageUrl = `${process.env.PUBLIC_BUCKET_URL}/user/${agent.id}/photo/${agent.profilePicture}`
      }

      return {
        firstName: agent.firstName || vm.getDefaultContactUsername(),
        lastName: agent.lastName,
        email: agent.email || vm.getDefaultContactEmail(),
        phone: agent.phone || vm.getDefaultContactPhone(),
        logoSrc: imageUrl,
      }
    }
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/services/shared-properties.js